import PropTypes from "prop-types"
import React from "react"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

function BoothTeam({ label, heading, description, people = [] }) {
  return (
    <Container section margin>
      <Heading
        label={label}
        title={heading}
        subtitle={description}
        decoration="line"
      />
      <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {people.map((person, idx) => (
          <PersonCard key={idx} {...person} />
        ))}
      </div>
    </Container>
  )
}

function PersonCard({
  name,
  title,
  photo,
  linkedin,
  meetingUrl,
  meetingLabel,
}) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-gray-100 bg-white p-6 text-center shadow-sm">
      {photo && (
        <img
          src={photo}
          alt={name}
          className="h-28 w-28 rounded-full object-cover object-top"
        />
      )}
      <h3 className="mt-4 text-xl font-bold text-gray-900">{name}</h3>
      <p className="mt-1 text-sm text-gray-500">{title}</p>
      {linkedin && (
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-2 text-sm font-medium text-lush hover:underline"
        >
          LinkedIn →
        </a>
      )}
      {meetingUrl && (
        <Button
          href={meetingUrl}
          target="_blank"
          color="green"
          size="small"
          className="mt-5 w-full justify-center"
        >
          {meetingLabel || "Book a Meeting"}
        </Button>
      )}
    </div>
  )
}

BoothTeam.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  people: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string,
      photo: PropTypes.string,
      linkedin: PropTypes.string,
      meetingUrl: PropTypes.string,
      meetingLabel: PropTypes.string,
    })
  ),
}

export default BoothTeam
